"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnrecognizedUrl = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../../gen-src/Localize");
var rootStyle = __assign(__assign({}, data_catalog_shared_1.vizPortalFontStyle), { flex: 1, position: 'relative', top: '15%', display: 'flex', flexDirection: 'column', alignItems: 'center' });
var rootClass = (0, data_catalog_shared_1.cssClass)('UnrecognizedUrlRoot', rootStyle);
function UnrecognizedUrl(props) {
    return (react_1.default.createElement("div", { className: rootClass },
        react_1.default.createElement("div", null, Localize_1.Messages.UnrecognizedUrl()),
        react_1.default.createElement(react_router_dom_1.Link, { to: props.backToButtonUrl }, props.backToButtonLabel)));
}
exports.UnrecognizedUrl = UnrecognizedUrl;
//# sourceMappingURL=UnrecognizedUrl.js.map